'use client';

import { c as _c } from "react/compiler-runtime";
import { useToast } from '@common/hooks';
import { useQueryClient } from '@tanstack/react-query';
import { type LottoOutcome, resolveLottoOutcome } from '../_utils/resolveLottoOutcome';
import { DEFAULT_RAFFLE_COST, LOTTO_STATE_QUERY_KEY, useLottoDraw } from './useLottoState';
export interface LottoDrawOutcome {
  variant: LottoOutcome;
  wonPoint: number;
}

/**
 * 리워드영상 완주 후 응모(lottoYN)를 실행하고 응답에서 결과 variant·당첨 포인트를 파생해
 * 콜백으로 넘긴다. 결과를 어떤 다이얼로그 액션에 태울지만 호출부가 정한다.
 * isDrawing은 응모 요청~캐시 재동기화까지의 진행 신호(호출부의 블로킹 로딩용).
 */
export const useDrawLottoOutcome = () => {
  const $ = _c(7);
  const queryClient = useQueryClient();
  const {
    toast
  } = useToast();
  const {
    mutate: draw,
    isPending: isDrawing
  } = useLottoDraw();
  let t0;
  if ($[0] !== draw || $[1] !== queryClient || $[2] !== toast) {
    t0 = (placementId, onOutcome) => {
      draw({
        body: {
          placementId,
          sspType: "REWARDED_VIDEO",
          lottoYN: true
        }
      }, {
        onSuccess: response => {
          const lottery = response.context?.lottery;
          if (!lottery) {
            toast({
              message: "\uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694",
              type: "fail"
            });
            return;
          }
          onOutcome({
            variant: resolveLottoOutcome({
              isWin: lottery.result === "WIN",
              remainingTicketCount: lottery.raffleTicketCount,
              requiredTicketCount: queryClient.getQueryData(LOTTO_STATE_QUERY_KEY)?.context?.raffleCost ?? DEFAULT_RAFFLE_COST
            }),
            wonPoint: lottery.wonPoint
          });
        },
        onError: () => {
          toast({
            message: "\uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694",
            type: "fail"
          });
        }
      });
    };
    $[0] = draw;
    $[1] = queryClient;
    $[2] = toast;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const drawLotto = t0;
  let t1;
  if ($[4] !== drawLotto || $[5] !== isDrawing) {
    t1 = {
      drawLotto,
      isDrawing
    };
    $[4] = drawLotto;
    $[5] = isDrawing;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};